import React from 'react';
import classNames from 'classnames';
import logo from '../../assets/images/logo-round.png';
import { useSelector } from 'react-redux';
import UserPopup from '../UserPopup/UserPopup';
import { useNavigate } from 'react-router-dom';
import styles from './Header.module.scss';
import { removeAccessToken } from '../../utils/access-token-storage'; // 假设你有一个工具函数来处理 token
const Header = React.memo(() => {
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);

  const onLogout = () => {
    removeAccessToken();
    navigate('/login');
  };

  return (
    <div className={styles.fixed}>
      <div className={styles.wrapper}>
        <div className={classNames(styles.logo, styles.title)}>
          <img src={logo} alt="logo" />
          HEYBAN
        </div>

        <div className={classNames(styles.item, styles.itemHoverable)}>
          <UserPopup onLogout={onLogout}>
            <div>{user && (user.name || user.username)}</div>
          </UserPopup>
        </div>
      </div>
    </div>
  );
});

export default Header;
